import React, {useState} from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import {ClickAwayListener} from '@material-ui/core'
import JourneyDropdown from './JourneyDropdown'
import {DraftSpan} from '../CoursesSelector/CoursesSelector'

const SelectorContainer = styled.div`
  position: relative;
`
const SelectControl = styled.div`
  box-shadow: none;
  height: 44px;
  cursor: pointer;
  border: 0.5px solid #BBBBBB;
  border-radius: ${props => props.open ? '5px 5px 0 0' : '5px'};
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;

`

const SelectPlaceholder = styled.div`
  padding: 0 15px;
  font-size: 1rem;
  font-weight: ${props => props.color ? 500 : 300};
  color: ${props => props.color ? '#' + props.color : '#999999'};
`

const SelectArrow = styled.span`
  display: inline-block;
  box-sizing: border-box;
  margin-right: 15px;
  border-color: #999 transparent transparent;
  border-style: solid;
  border-width: 5px 5px 2px;
  height: 0;
  width: 0;
  position: relative;

  &:hover {
    border-color: #666 transparent transparent;
  }
`

export const JourneySelector = ({journeys, onSelectJourney, initialSelectedJourney}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [selectedJourney, setSelectedJourney] = useState(initialSelectedJourney)
  const toggle = () => {
    setDropdownOpen(!dropdownOpen)
  }
  const handleSelectedJourney = (journey) => {
    setSelectedJourney(journey)
    onSelectJourney(journey)
  }
  return (
    <ClickAwayListener onClickAway={() => setDropdownOpen(false)}>
      <SelectorContainer>
        <SelectControl open={dropdownOpen} onClick={toggle}>
          {selectedJourney === null && <SelectPlaceholder>Select a journey.</SelectPlaceholder>}
          {selectedJourney && <SelectPlaceholder color={selectedJourney.master_course.color}>{selectedJourney.name}<DraftSpan>{!selectedJourney.marked_ready_for_enrollment_at ? '(Draft)' : ''}</DraftSpan></SelectPlaceholder>}
          <SelectArrow onClick={toggle}/>
        </SelectControl>
        {dropdownOpen && <JourneyDropdown journeys={journeys} onSelectJourney={handleSelectedJourney} selectedJourney={selectedJourney} toggle={toggle}/>}
      </SelectorContainer>
    </ClickAwayListener>
  )
}

JourneySelector.propTypes = {
  courses: PropTypes.array
}

export default JourneySelector



// WEBPACK FOOTER //
// ./src/components/modal/CreateOrEditCourseModal/InputComponents/JourneySelector/JourneySelector.js